<template>
    <ConfirmDialog group="dialog" />
    <Toast />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Purchase.view.Heading') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Company Name') }}:</label>
                    <div class="p-col-12 p-md-10">{{ company_name == null ? 'N/A' : company_name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Type') }}:</label>
                    <div class="p-col-12 p-md-10">{{ sub_type == null ? 'N/A' : sub_type }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Industry') }}:</label>
                    <div class="p-col-12 p-md-10">{{ industry_name == "" ? 'N/A' : industry_name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Email') }}:</label>
                    <div class="p-col-12 p-md-10">{{ email }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Phone') }}:</label>
                    <div class="p-col-12 p-md-10">{{ formatPhoneNumber(phone_number) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Validtime') }}:</label>
                    <div class="p-col-12 p-md-10">{{ validity == null ? 'N/A' : validity }} {{ $t('Days') }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Noofcases') }}:</label>
                    <div class="p-col-12 p-md-10">{{ cases == null ? 'N/A' : cases }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Discountrate') }}:</label>
                    <div class="p-col-12 p-md-10">{{ discount_price == null || null ? 'N/A' : discount_price + '%' }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Originalprice') }}:</label>
                    <div class="p-col-12 p-md-10">{{ main_original_price == null || null ? 'N/A' : main_original_price + '&nbsp;' + '초코'
                    }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Offeredprice') }}:</label>
                    <div class="p-col-12 p-md-10">{{ main_price == null || null ? 'N/A' : main_price + '&nbsp;' + '초코'}}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.PurchaseDate') }}:</label>
                    <div class="p-col-12 p-md-10">{{ created_at == "" ? 'N/A' : FormatDate(created_at) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.AppliedDate') }}:</label>
                    <div class="p-col-12 p-md-10">{{ applied_date == null ? 'N/A' : FormatDate(applied_date) }}</div>
                </div>
                <div class="p-field p-col-12 p-md-12 select">
                    <label for="nameuser"><b>{{ $t('Purchase.view.Refund') }}</b></label><br>
                    <span v-if="is_gifted == 1">{{ $t('Purchase.view.Gifted') }}</span>
                    <span v-else-if="is_refunded == 1">{{ $t('Purchase.view.Refunded') }}</span>
                    <span v-else-if="ad_status == 'closed'">{{ $t('Purchase.view.Closed') }}</span>
                    <span v-else-if="ad_status == 'used'">{{ $t('Purchase.view.Used') }}</span>
                    <span v-else-if="ad_package_id">{{ $t('Purchase.view.Refundable') }}</span>
                    <span v-else>
                        <div class="p-field p-col-12 p-md-2 select">
                            <Dropdown v-model="purchase_id" :options="refundDropdown" optionLabel="name"
                                optionValue="code" :placeholder="$t('Purchase.list.Select')" name="name"
                                id="first_category" @change="updateRefund" />
                        </div>
                    </span>

                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Purchase.view.Note') }}</label>
                    <div class="textbox p-col-12 p-md-12" :style="error?.note ? 'border: 1px solid red' : ''">
                        <Textarea :placeholder="$t('Purchase.view.Desc')" :autoResize="true" rows="5" cols="30"
                            v-model="note" style="width: 100%; margin-left: 0px; margin-top: 14px" id="areatext"
                            @keydown.space="preventLeadingSpace" />
                    </div>
                    <div class="text-red">{{ error.note }}</div>
                </div>
                <div class="p-col-12">
                    <div class="p-d-flex p-jc-between">
                        <div style="margin-left:-12px;">
                            <Button @click="Update" :label="$t('Purchase.view.Save')"
                                class="p-button-outlined p-button-success p-mr-2 p-mb-2" style="background: black; color: white;" icon="pi pi-check" iconPos="left"></Button>
                        </div>
                        <div id="back">
                            <Button @click="$router.go(-1)" :label="$t('Purchase.view.Back')"
                                class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-replay" iconPos="left" style="background: white; color: black;"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
// import ProductCategoryService from '../../../service/API/ProductCategoryService';
import PurchaseService from '../../service/API/PurchaseService';
import moment from 'moment';
// import validatePurchaseNote from '../../validations/Purchase/validatePurchaseNote';
// import {useRouter} from 'vue-router'
export default {
    data() {
        return {
            disInq: true,
            renderTxt: false,
            replied: false,
            replyText: '',
            replyStatus: 'answered',
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},
            access_times: '',
            address: '',
            name: '',
            company_postal_code: '',
            email: '',
            id: '',
            gender: '',
            industry_name: '',
            last_login: '',
            note: '',
            ad_package_id: '',
            ad_status: '',
            is_gifted: '',
            phone_number: '',
            job_type: '',
            working_region: '',
            no_of_cases: '',
            refundDropdown: [
                { name: '예', code: '1' },
                { name: '아니요', code: '0' },
            ],
            refundDropdowns: '',
            is_refunded: '',
            p_note: '',
            main_discount: '',
            main_original_price: '',
            main_price: '',
            cases: '',
            error: {},
            validity: '',
            purchase_id: '',
            status: ''
        };
    },
    created() {
        this.purchaseService = new PurchaseService();
    },
    methods: {
        del(id) {
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: '취소',
                accept: () => {
                    axios({ method: 'delete', url: `api/v1/admin/job-seeker/delete`, data: { user_id: id } }).then((res) => {
                        console.warn(res);
                        this.$router.push({ name: 'Purchase Management' });
                    });

                    this.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                },
            });
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, "");
        },
        Update() {
            // let vcheckData = {

            //     note: this.note,
            //     // type: this.dropdownValueType == null ? '' : 'something',
            // };
            // const { isInvalid, error } = validatePurchaseNote(vcheckData);
            // if (isInvalid) {
            //     this.error = error;
            //     console.log(error);
            // } else {
            //     console.log(this.formData);
            return axios
                .post('api/v1/admin/purchase/update-purchase', { purchase_id: this.$route.params.id, note: this.note })
                .then(() => {
                    // alert('성공적으로 저장');
                    // this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Succesfully Published.', life: 3000 });
                    this.$router.push({ name: 'Purchase Management' });
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '구매 정보가 저장되었습니다.', life: 3000 });
                    }, 500);
                });
            // }
        },


        updateRefund() {
            // alert('herdfdfd')
            // alert(this.$route.params.id)
            // if (this.is_refunded == '1') {
            return axios
                .post('api/v1/admin/purchase/update-purchase-refund', {
                    purchase_id: this.$route.params.id,
                    // status: this.status,
                })
                .then((res) => {
                    console.log(res)
                    this.$toast.add({ severity: 'info', summary: this.$t('Confirmed'), detail: this.$t('Succesfully Updated'), life: 3000 });
                    // this.$router.push({ name: 'ListUserManagement' });
                    console.log(res);
                    setTimeout(() => {
                        this.$router.push({ path: '/PurchaseManagement/PurchaseManagementlist', query: { alert: 1, severity: 'success', summary: 'Success Message', msg: this.$t('Succesfully Updated') } });
                    }, 1000);
                });
            // } else {
            //     // this.deleteNote(this.$route.params.id);
            // }
        },
        FormatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD');
            }
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            }
            else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            }
            else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }

           
        },
    },
    mounted() {
        this.purchaseService.viewPurchase(this.$route.params.id).then((result) => {
            // console.log(result);
            this.company_name = result[0].company_name;
            this.email = result[0].email;
            this.type = result[0].type;
            this.phone_number = result[0].phone_number;
            this.validity = result[0].validity;
            this.applied_date = result[0].applied_date;
            this.note = result[0].p_note;
            this.main_original_price = result[0].main_original_price;
            this.discount_price = result[0].discount_price;
            this.main_price = result[0].main_price;
            this.sub_type = result[0].sub_type;
            this.created_at = result[0].created_at;
            this.industry_name = result[0].industry_name;
            this.cases = result[0].cases;
            this.is_gifted = result[0].is_gifted;
            this.is_refunded = result[0].is_refunded;
            this.ad_package_id = result[0].ad_package_id;
            this.ad_status = result[0].ad_status;
            // this.status = data.status;
            // this.mydata = data;
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}

.select {
    flex-wrap: wrap;
    margin-right: -1rem;
    margin-left: -1rem;
}

#areatext {
    height: 34vh;
}

div#back {
    margin-right: -20px;
}
</style>